import script from "./NicknameDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NicknameDialog.vue?vue&type=script&setup=true&lang=js"

import "./NicknameDialog.vue?vue&type=style&index=0&id=45d46686&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d46686"]])

export default __exports__